// Copied from transition-web/src/libs/SignedInMachine.tsx
// TODO: Adapt for new structure and types

import invariant from 'invariant'
import dayjs from 'dayjs'
import { OnboardingChapter } from '../../../pure-js/enums/OnboardingChapter'
import { hasAcknowledgedPrivacyNotice, PRIVACY_NOTICE } from '../../../pure-js/libs/privacyNotice'
import { SignedInQueryParams } from '../../../pure-js/types/QueryParamTypes'
import { SignedInState, SignedInSteps } from '../types/SignedInTypes'
import { User } from '../../../pure-js/types/User'
import { State } from '../hooks/useAppState'
import { getTeam, getUser, updateTeam, updateUser } from './DBApiHandlerDeprecated'
import { auth } from './Firebase'

export const onPressContinue = (
  signedInState: SignedInState,
  state: State,
  _setState: (state: State) => void,
  f = { getTeam, updateTeam, updateUser, auth }
): Promise<SignedInState> =>
  Promise.resolve().then(async () => {
    switch (signedInState.step) {
      case SignedInSteps.SIGN_UP_FORM: {
        const { displayName, phone, privacyNoticeAcknowledged } = signedInState.data
        invariant(privacyNoticeAcknowledged, 'privacy-notice-not-acknowledged')

        const privacyNoticeAcknowledgement = {
          privacyPolicyAgree: true,
          privacyNoticeVersion: PRIVACY_NOTICE.version,
          privacyNoticeAcknowledgedAt: dayjs().format()
        }

        await f.updateUser({ id: state.user.id, displayName, phone, ...privacyNoticeAcknowledgement })

        // Update local state with the new user info so onLoginToIntraction has the latest data
        _setState({
          ...state,
          user: {
            ...state.user,
            displayName,
            phone,
            ...privacyNoticeAcknowledgement
          },
          isAuthInitialized: true
        })

        // After completing profile and acknowledging the privacy notice, go to dashboard (return undefined)
        // Step can be undefined in certain states - using unknown cast through type assertion
        return { ...signedInState, step: undefined as unknown as SignedInSteps }
      }

      default:
        throw new Error(`Unknown step: ${signedInState.step}`)
    }
  })

export async function getFirstStep(
  state: State,
  _queryParams: SignedInQueryParams,
  f = { getTeam, getUser }
): Promise<SignedInSteps | undefined> {
  const user = await f.getUser(state.user.id)

  // Check if user has complete profile info (displayName, email, and privacy notice acknowledgement)
  if (!hasCompleteUserInfo(user)) {
    return SignedInSteps.SIGN_UP_FORM
  }

  // All steps completed - go to dashboard
  return undefined
}

export const hasCompletedIntroduction = (u?: User): boolean => {
  // Check if user has completed all required onboarding steps
  // Note: We check completedOnboardingSteps, not team membership
  // Users can complete onboarding before joining a team
  return u?.completedOnboardingSteps?.includes(OnboardingChapter.Introduction) || false
}

export const hasCompleteUserInfo = (u?: User): boolean => {
  const hasDisplayName = !!u?.displayName
  const hasEmail = !!u?.email
  const hasAcknowledgedNotice = hasAcknowledgedPrivacyNotice(u)
  const result = hasDisplayName && hasEmail && hasAcknowledgedNotice

  return result
}
